var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 37,
    viewBox: "0 0 40 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.501 26.5392C18.501 25.7112 19.173 25.0272 20.001 25.0272C20.829 25.0272 21.501 25.6892 21.501 26.5172V26.5392C21.501 27.3672 20.829 28.0392 20.001 28.0392C19.173 28.0392 18.501 27.3672 18.501 26.5392Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.59168 34.8358H34.5557C36.8497 34.7158 38.6137 32.7618 38.4957 30.4678C38.4697 30.0038 38.3697 29.5458 38.1937 29.1178L23.6397 3.6458C22.5277 1.6358 19.9977 0.907801 17.9877 2.0218C17.3037 2.3978 16.7397 2.9618 16.3617 3.6458L1.80768 29.1178C0.94368 31.2458 1.96768 33.6698 4.09368 34.5358C4.52568 34.7098 4.98168 34.8098 5.44568 34.8358",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9805 20.7922V14.5922",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorLight);
export default __webpack_public_path__ + "static/media/errorLight.8e95e7bcf5596ac8cf7679072ad26b06.svg";
export { ForwardRef as ReactComponent };